import AssociatesScreen from "./pages/associatesList";
import AssociatesEditScreen from "./pages/associatesForm";

export const AssociatesRoutes = [
    { path: "/associados", exact: true ,component: AssociatesScreen },
    { path: "/associados/edit/:id",exact: true , component: AssociatesEditScreen },
    { path: "/associados/novo", component: AssociatesEditScreen },
    { path: "/associados/novo/proposal", component: AssociatesEditScreen },
];
